export default __webpack_public_path__ + "static/media/img-c-00-bg-gtl@2x.833b7cb0.jpg";